import React from "react";
import Meta from "./../components/Meta";
import AuthSection from "./../components/AuthSection";
import { useRouter } from "./../util/router";

function AuthPage(props) {
  const router = useRouter();
  
  // Get custom message from URL if it exists
  const message = router.query.message || "";

  return (
    <>
      <Meta title="Auth" />
      <AuthSection
        size="md"
        bgColor="bg-white"
        bgImage=""
        bgImageOpacity={1}
        textColor=""
        type={router.query.type}
        afterAuthPath={router.query.next || "/"}
        message={message}
      />
    </>
  );
}

export default AuthPage;
